/* unplugin-vue-components disabled */import { render } from "./prophet.vue?vue&type=template&id=0351d21e&scoped=true"
import script from "./prophet.vue?vue&type=script&lang=js"
export * from "./prophet.vue?vue&type=script&lang=js"

import "./prophet.vue?vue&type=style&index=0&id=0351d21e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0351d21e"]])

export default __exports__